import { Injectable } from "@angular/core";
import * as localforage from "localforage";
import { LOCAL_STORAGE_KEYS } from "../global/constants";
import { EncryptionService } from "./encryption.service";

@Injectable()
export class LocalStorageService {
  constructor(private encryptionService: EncryptionService) {}

  setLocalStore = (key, data) => {
    try {
      localStorage.setItem(key, this.encryptionService.encrypt(data));
    } catch (error) {
      localStorage.setItem(key, data);
    }
  };

  getLocalStore = (key) => {
    const encryptedData = localStorage.getItem(key);
    try {
      if (encryptedData) {
        return this.encryptionService.decrypt(encryptedData);
      }
    } catch (error) {
      return encryptedData;
    }
  };

  clearStorageFor = (key) => {
    return localStorage.removeItem(key);
  };

  clearStorage = () => {
    return localStorage.clear();
  };

  // store particular key details
  setDataInIndexedDB(key, value) {
    let valueStr = JSON.stringify(value);
    try {
      valueStr = this.encryptionService.encrypt(valueStr);
    } catch (error) {}
    return localforage
      .setItem(key, valueStr)
      .then(() => {})
      .catch(() => {});
  }

  // fetch particular key details
  async getDataFromIndexedDB(key) {
    return new Promise((resolve, reject) => {
      localforage
        .getItem(key)
        .then((result: any) => {
          try {
            const decryptedData = this.encryptionService.decrypt(result);
            resolve(JSON.parse(decryptedData));
          } catch (error) {
            resolve(JSON.parse(result));
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // Database has been entirely deleted.
  clearDataFromIndexedDB() {
    this.clearStorage();
    return localforage.clear();
  }

  async clearDataFromIndexedDBWIthSafePhoneCode() {
    const lastPhoneCode = await this.getDataFromIndexedDB(
      LOCAL_STORAGE_KEYS.MOBILECOUNTRYCODE,
    );
    await this.clearDataFromIndexedDB();
    await this.setDataInIndexedDB(
      LOCAL_STORAGE_KEYS.MOBILECOUNTRYCODE,
      lastPhoneCode,
    );
  }

  // For Remove Particular Field/Key
  removeDataFromIndexedDB(key) {
    return new Promise((resolve, reject) => {
      localforage
        .removeItem(key)
        .then((result: any) => {
          const remove = "Key Removed";
          return resolve(remove);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  }
}
